import request from '@/utils/request';
const userUrl = "/userinfo";
// 获取日志列表
export function listLog(query: object) {
  return request({
    url: userUrl + '/monitor/operlog/list',
    method: 'get',
    params: query,
  });
}
